import { LayerObjectAdapter } from '@/utils/layer/LayerObjectAdapter';

export default function adapterArrayToKeyValue<T extends LayerObjectAdapter>(
  array: T[],
): Record<string, T> {
  return array.reduce(
    (accumulator, currentItem) => {
      accumulator[currentItem.getOriginalId()] = currentItem;
      return accumulator;
    },
    {} as Record<string, T>,
  );
}
